import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import {
  DatabaseError,
  DataIntegrityError,
  OpenSearchError,
} from "../auth/errors";

const GetConversationCountsInput = Schema.Struct({
  views: Schema.Array(
    Schema.Struct({
      viewKey: Schema.String,
      filterGroup: Schema.NullOr(Schema.String),
    }),
  ),
});

export const ConversationCountsGroup = HttpApiGroup.make("conversationCounts")
  .add(
    endpoint.merchant
      .post("getConversationCounts", "/conversation-counts")

      .setPayload(GetConversationCountsInput)
      .addSuccess(Schema.Record({ key: Schema.String, value: Schema.Number }))
      .addError(HttpApiError.Forbidden)
      .addError(OpenSearchError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
